<!-- HelpCenter -->
<template>
  <div class="container">
    <div class="header">
      <div class="search-box">
        <img class="search-icon" src="@/assets/helpCenter/icon_search.png" alt="">
        <input class="search-input" type="text" placeholder="搜一搜" v-model.trim="searchText">
        <img class="search-clear" src="@/assets/helpCenter/clear.png" alt="" @click="clearSearch">
      </div>
      <div class="search-cancel" @click="goHelpCenter">取消</div>
    </div>
    <help-list :list="list"></help-list>
  </div>
</template>

<script>
import config from '@/config/config'
import helpData from './help_config'
import helpDataWatch from './help_config_watch'
import HelpList from './list'

export default {
  components: { HelpList },
  data() {
    return {
      originList: [],
      list: [],
      searchText: ''
    }
  },
  watch: {
    searchText (text) {
      // 输入时查找内容
      if (!text) {
        this.list = this.originList
        return
      }
      let list = []
      for (let i = 0; i < this.originList.length; i++) {
        // 先查找标题，没有命中则继续查找关键词
        if (this.originList[i].title.indexOf(text) > -1) {
          list.push(this.originList[i])
          continue
        }
        if (this.originList[i].keywords) {
          for (let j = 0; j < this.originList[i].keywords.length; j++) {
            if (this.originList[i].keywords[j].indexOf(text) > -1) {
              list.push(this.originList[i])
              break
            }
          }
        }
      }
      this.list = list
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData () {
      let tempData = []
      switch (this.$route.query.type) {
        case 'watch':
          tempData = helpDataWatch
          break
        default:
          tempData = helpData
      }
      // 压平数据，以便索引
      let list = []
      tempData.list.forEach(item => {
        list.push(...item.list)
      })
      this.originList = list
      this.list = list
    },

    clearSearch () {
      this.searchText = ''
    },

    goHelpCenter () {
      const _this = this
      window.location.href = `${config.siteRoot}/helpcenter?type=${_this.$route.query.type}`
    }
  },
  mounted () {
    
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.container {
  padding-top: .14rem;
  background: #fff;
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .32rem;
  box-sizing: border-box;
  .search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 0 .24rem 0 .24rem;
    height: .64rem;
    box-sizing: border-box;
    background: #f4f4f8;
    border-radius: 200px;
    .search-icon {
      display: block;
      width: .32rem;
      height: .32rem;
    }
    .search-input {
      display: block;
      flex: 1;
      margin: 0 .16rem;
      height: 100%;
      padding: 0;
      color: #604038;
      font-size: .28rem;
      font-weight: bold;
      border: none;
      outline: none;
      background: #f4f4f8;
      &::-webkit-input-placeholder {
        color: #c4c4c6;
        font-weight: normal;
      }
    }
    .search-clear {
      display: block;
      width: .32rem;
      height: .32rem;
    }
  }
  .search-cancel {
    display: block;
    margin-left: .32rem;
    color: #5b413a;
    font-size: .28rem;
    font-weight: bold;
  }
}

</style>
